import { createAction } from '@reduxjs/toolkit';
import { handleSignOut } from 'lib/utils/amplify'

// Logout
export const logoutSuccess = createAction('LOGOUT');
export const setNewAccessToken = createAction('SET_NEW_ACCESS_TOKEN');

export const logout = () => async dispatch => {
    try {
        await handleSignOut();
        dispatch(logoutSuccess());
    } catch (e) {
        console.error(e);
    }
}




